/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Answer_Feedback_Error_InvalidInputs */

const es_co2_answer_feedback_error_invalid = /** @type {(inputs: Answer_Feedback_Error_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La valoración no es válida. Revisa las razones e intenta de nuevo.`)
};

/**

* @param {Answer_Feedback_Error_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const answer_feedback_error_invalid = /** @type {((inputs?: Answer_Feedback_Error_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Answer_Feedback_Error_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_answer_feedback_error_invalid(inputs)
});